import { Stack } from "@mui/system";
import { Container, Grid, Typography } from "@mui/material";
import CustomAppBar from "../../../components/CustomAppBar";
import { useNavigate } from "react-router";

import MenuBar from "../../menuBar";
import { useResponsive } from "../../../hooks/useResponsive";
import { useTranslation } from "react-i18next";

const StorageAgreeementPage = () => {
  const navigate = useNavigate();
  const lgUp = useResponsive("up", "lg");
  const { t } = useTranslation();

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <CustomAppBar
        title={"Reservations"}
        showBackButton={true}
        onBackButtonClick={() => {
          navigate(-1);
        }}
      />
      <MenuBar />
      <Container
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Grid container direction={"row"} sx={{ mt: 2 }}>
          <Typography variant="h5" color={"primary.main"}>
            {t("pages.storageAgreement.pageHeading")}
          </Typography>
        </Grid>

        <Stack sx={{ mt: 2 }} spacing={2}>
          <Typography variant="h5" color={"primary.black"}>
            {t("pages.storageAgreement.text01")}
          </Typography>
        </Stack>
      </Container>
    </div>
  );
};

export default StorageAgreeementPage;
